import {
  IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useProductVersionsDropDownData } from "../../hooks/dropdown/useProductVersionsDropDownData";

type DisplayProductVersionsDropDownProps = {
  selectedProductValue: string;
  callbackFn: (v: any) => void;
};

export const DisplayProductVersionsDropDown: React.FC<
  DisplayProductVersionsDropDownProps
> = ({ selectedProductValue, callbackFn }) => {
  //  const { t } = useTranslation();

  const { t } = useTranslation();

  const [productVersions, setProductVersions] =
    useState<IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem>();

  let allProductVersions = useProductVersionsDropDownData(selectedProductValue);

  useEffect(() => {
    if (allProductVersions && allProductVersions.status === "success") {
      setProductVersions(allProductVersions.data);
    }
  }, [allProductVersions]);

  return (
    <SelectField
      name="version_id"
      label={t("licenses.basic.detail.generate.version")}
      options={(productVersions ? productVersions.list : []).map((pVersion) => {
        console.log(pVersion);
        return {
          label: pVersion.version_number!,

          value: pVersion.id!,
        };
      })}
      showSearch
      optionFilterProp="label"
      onChange={(value: string, option: any) => {
        console.log(value);

        callbackFn(option);
      }}
    />
  );
};
